
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/netzwerk/partner",
      function () {
        return require("private-next-pages/netzwerk/partner/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/netzwerk/partner"])
      });
    }
  